import React from 'react'

import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import { useTheme } from 'styled-components'

import { CheckboxContainer } from './styles'

interface IProps {
  isChecked: boolean
}

export function Checkbox({ isChecked }: IProps) {
  const theme = useTheme()

  return (
    <CheckboxContainer>
      {isChecked ? (
        <MdCheckBox size={20} color={theme.colors.info} />
      ) : (
        <MdCheckBoxOutlineBlank size={20} color={theme.colors.info} />
      )}
    </CheckboxContainer>
  )
}
